﻿export class ApiResponse {
    statusCode: any;
    reasonPhrase: string;
    isSuccess: boolean;
    data: any;
    message: string;

    constructor() {
        this.statusCode = 0;
        this.reasonPhrase = '';
        this.isSuccess = false;
        this.data = {};
        this.message = '';
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/models/api-response.ts
 **/